export const PRIMARY_STORAGE_KEY = "pcolor";

export const SECONDARY_STORAGE_KEY = "scolor";
